import { useState } from "react";

/**
 * A toggle shows the value it was just asked for while its save is in flight; once the request settles the stored
 * (server-authoritative) value shows again. Without this a controlled checkbox snaps back until the server answers.
 */
export function usePendingToggles() {
  const [pending, setPending] = useState<Record<string, boolean>>({});
  const shown = (key: string, stored: boolean) => pending[key] ?? stored;
  const track = async (key: string, value: boolean, save: () => Promise<void>) => {
    setPending((current) => ({ ...current, [key]: value }));
    try {
      await save();
    } finally {
      setPending((current) => { const next = { ...current }; delete next[key]; return next; });
    }
  };
  return { shown, track };
}
